import { mapState } from 'vuex';
import * as adapi from '~/utils/adapi';
import * as permissions from '~/utils/permissions';
import FormInput from '~/components/form-input/FormInput.vue';

export default {
  components: {
    'form-input': FormInput,
  },
  data() {
    return {
      code: null,
      loading: false,
    };
  },
  computed: {
    ...mapState('auth', { currentUser: 'user' }),
  },
  methods: {
    validate() {
      const fin = () => {
        this.loading = false;
      };
      this.loading = true;

      adapi
        .post(`campaigns/${this.code}/validate`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.campaign-validate.campaign-validated') });
          this.code = null;
          fin();
        })
        .catch(error => {
          const message =
            error.code === 404
              ? this.$t('pos.campaign-validate.campaign-not-found')
              : this.$t('pos.campaign-validate.restriction');
          this.$toast.error({ message });
          fin();
        });
    },
    exportData() {
      adapi.get('campaigns/export-unvalidated')
        .then(result => {
          const link = document.createElement('a');
          link.href = result;
          link.setAttribute('download', '');

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$toast.info({ message: this.$t('pos.search-table.export-completed') });
        })
        .catch(error => {
          this.$toast.error({ message: error });
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (permissions.canGlobal(vm.currentUser, 'Campaign', ['validateCampaigns'])) {
        next();
      } else {
        next('/');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/campaign-validate/CampaignValidate.js